import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var chipContent = createRuntimeFn({defaultClassName:'fx_b6b0f3e6_16q4jg3',variantClassNames:{size:{'default':'fx_b6b0f3e6_16q4jg4',large:'fx_b6b0f3e6_16q4jg5'}},defaultVariants:{size:'default'},compoundVariants:[]});
var chipContentHorizontalGap = 'var(--fx_b6b0f3e6_16q4jg0)';

export { chipContent, chipContentHorizontalGap };
//# sourceMappingURL=content.vanilla.mjs.map
